import { render, staticRenderFns } from "./ShareBySms.vue?vue&type=template&id=2d8d9b84&lang=pug"
import script from "./ShareBySms.vue?vue&type=script&lang=js"
export * from "./ShareBySms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports